export default "__VITE_ASSET__B8sFpK54__"